<ng-container *ngIf="costCenterState$ | async as state">
    <div class="cost-center-container mat-elevation-z8">
        <div class="table-header">
            <mat-form-field subscriptSizing="dynamic">
                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value" (click)="filter.value=''; applyFilter('');">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <mat-form-field style="width: 40%" subscriptSizing="dynamic">
                <mat-label>{{ "app.model.cost-center.validity.label" | translate }}</mat-label>
                <mat-date-range-input [formGroup]="formGroup" [rangePicker]="picker">
                    <input matStartDate formControlName="start">
                    <input matEndDate formControlName="end">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
                <button mat-icon-button matSuffix aria-label="clear" (click)="filter.value=''; formGroup.reset()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <button mat-mini-fab
                    color="primary"
                    matTooltip="{{ 'app.page.cost-center.actions.add-group.label' | translate }}"
                    (click)="onOpenCostCenterGroupDialog()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" multiTemplateDataRows>

                <ng-container matColumnDef="processOrder">
                    <th mat-header-cell *matHeaderCellDef>
                        <button mat-icon-button *ngIf="!isExpandAll"><mat-icon>keyboard_arrow_down</mat-icon></button>
                        <button mat-icon-button *ngIf="isExpandAll"><mat-icon>keyboard_arrow_up</mat-icon></button>
                        {{ "app.model.cost-center-group.process-order.label" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button aria-label="expand row" (click)="toggleExpand(element); $event.stopPropagation()">
                            <mat-icon *ngIf="!isExpandedMap[element.id]">keyboard_arrow_down</mat-icon>
                            <mat-icon *ngIf="isExpandedMap[element.id]">keyboard_arrow_up</mat-icon>
                        </button>
                        <span *ngIf="element.id !== 0">{{element.processOrder}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-center-group.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <span *ngIf="element.id !== 0">{{element.name}}</span>
                        <span *ngIf="element.id === 0">{{"app.model.cost-center-no-group.label" | translate}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="add-button">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" class="group-actions">
                        <ng-container *ngIf="element.id !== 0">
                            <button mat-icon-button
                                    matTooltip="{{ 'app.page.cost-center.actions.edit.label' | translate }}"
                                    (click)="onOpenCostCenterGroupDialog(element)">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-icon-button
                                    color="warn"
                                    matTooltip="{{ 'app.page.cost-center.actions.delete-group.label' | translate }}"
                                    (click)="onDeleteCostCenterGroup(element)"
                                    [disabled]="element.costCenters.length !== 0">
                                <mat-icon>delete</mat-icon>
                            </button>
                            <button mat-mini-fab
                                    color="primary"
                                    matTooltip="{{ 'app.page.cost-center.actions.add.label' | translate }}"
                                    (click)="onAddKostenstelle(element.id)">
                                <mat-icon>add</mat-icon>
                            </button>
                        </ng-container>
                    </td>
                </ng-container>


                <ng-container matColumnDef="expandedRow">
                    <td mat-cell *matCellDef="let kostenstellengruppe" [attr.colspan]="state.costCenterGroupColumns.length">
                        <div class="kostenstellen-detail" [@detailExpand]="isExpandedMap[kostenstellengruppe.id] ? 'expanded' : 'collapsed'">
                            <table mat-table [dataSource]="kostenstellengruppe.costCenters">

                                <ng-container matColumnDef="shortName">
                                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-center.short-name.label" | translate }}</th>
                                    <td mat-cell *matCellDef="let element">
                                        <ng-container *ngIf="element.shortName != null && element.shortName != ''; else displayPlaceholder">{{element.shortName}}</ng-container>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-center.label" | translate }}</th>
                                    <td mat-cell *matCellDef="let element">
                                        {{element.name}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="assignments">
                                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-center.reference-values.label" | translate }}</th>
                                    <td mat-cell *matCellDef="let element">
                                        <button mat-icon-button
                                                matTooltip="{{ 'app.page.cost-center.actions.edit-reference-sizes.label' | translate }}"
                                                (click)="showBezugsgroessenDialog(element)">
                                            <mat-icon>list</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="hourlyWages">
                                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-center.hourly-wage.label" | translate }}</th>
                                    <td mat-cell *matCellDef="let element">
                                        <button mat-icon-button
                                                matTooltip="{{ 'app.page.cost-center.actions.hourly-wages.label' | translate }}"
                                                (click)="onOpenHourlyWageDialog(element)">
                                            <mat-icon>euro</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="actions">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element" class="cost-center-actions">
                                            <button mat-icon-button
                                                    matTooltip="{{ 'app.page.cost-center.actions.edit.label' | translate }}"
                                                    (click)="onEditKostenstelle(element)">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                            <button mat-icon-button
                                                    color="warn"
                                                    matTooltip="{{ 'app.page.cost-center.actions.delete.label' | translate }}"
                                                    (click)="onDeleteCostCenter(element)">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="state.costCenterColumns;"></tr>
                                <tr mat-row *matRowDef="let row; columns: state.costCenterColumns"></tr>
                            </table>
                        </div>

                    </td>
                    <ng-template #displayPlaceholder>-</ng-template>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="state.costCenterGroupColumns; sticky: true" (click)="isExpandAll ? collapseAll() : expandAll()"></tr>
                <tr mat-row *matRowDef="let row; columns: state.costCenterGroupColumns;"
                    class="kostenstellenGruppeRow"
                    [class.example-expanded-row]="isExpandedMap[row.id]"
                    (click)="toggleExpand(row)"
                ></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedRow']" class="kostenstellen-row"></tr>
            </table>
        </div>
    </div>
</ng-container>
